/* eslint-disable react/no-string-refs */
import React, { Component } from 'react';
import Select from 'react-select';
import { Dropdown } from 'semantic-ui-react';
import { EnhancedDropdown } from '../defaultClassComponents.jsx';
import DynamicField from './DynamicField.jsx';
import OctetReplacementField from './OctetReplacementField.jsx';
import SelectOptions from './SelectOptions.jsx';
import emitter from '../../util/eventEmitter.js';
import PropertyValue from '../../util/propertyValue';

class FieldItem extends Component {
  constructor(props) {
    super(props);

    this.state = this.parseInitialState(props);
    this.dropdownOptions = [
      { key: 'opt1', text: 'Raw Value', value: 'value' },
      { key: 'opt2', text: 'Property Reference', value: 'reference' },
    ];
    this.octetPrefixes = ['append', 'octet', 'octet_replacement'];
    this.classes = this.getClasses();
  }

  // eslint-disable-next-line react/no-deprecated
  componentWillReceiveProps(props) {
    this.setState(this.parseInitialState(props));
    this.publishUpdate(props);
  }

  publishUpdate(props) {
    if (this.props.type === 'netmask' && !this.props.multiple) {
      let reference = this.hasReference(props)
        ? props.metadata.reference
        : null;

      emitter.emit(
        'propertyupdate',
        new PropertyValue(props.propertyId, props.value, reference),
      );
    }
  }

  onAppendUpdate(newAppendValue) {
    this.props.ipFieldData.onAppendChange(this.props.index, newAppendValue);
  }

  hasReference(props) {
    return (
      props.metadata &&
      typeof props.metadata === 'object' &&
      Object.prototype.hasOwnProperty.call(props.metadata, 'reference')
    );
  }

  parseInitialState(props) {
    let { value, dropdown } = this.getValueAndDropdown(props);

    return {
      value: value,
      dropdown: dropdown,
      button: props.fixed,
      error: props.error,
      selectedProperty: this.getReferenceOption(value),
    };
  }

  getValueAndDropdown(props) {
    let value, dropdown;

    if (props.value === `$${props.initialReferenceState}` && props.isHash) {
      dropdown = 'reference';
      value = '';
    } else if (this.hasReference(props)) {
      dropdown = 'reference';
      value = props.metadata.reference;
    } else {
      dropdown = 'value';
      value = props.value;
    }
    return { value: value, dropdown: dropdown };
  }

  getReferenceOption(value) {
    return this.props.references.find((opt) => {
      return opt.value == value;
    });
  }

  getClasses(props = this.props) {
    let classes = ['TextFieldItem'];

    if (props.semantic) {
      classes.push('field');
    }
    if (props.multiple) {
      classes.push('multiple');
    }
    if (props.outside) {
      classes.push('outside');
    }
    if (this.hasOptionsToReference(props)) {
      classes.push('references');
    }
    return classes;
  }

  hasPropertySelected(state = this.state) {
    return Object.entries(state.selectedProperty || {}).length > 0;
  }

  selectDropdown(value) {
    let metadata;

    if (value === 'reference') {
      metadata = { reference: this.props.initialReferenceState };
    } else if (value === 'value') {
      // eslint-disable-next-line no-unused-vars
      const { reference, ...remainingMetadata } = this.props.metadata;

      metadata = remainingMetadata;
    }
    this.setValue('', metadata);
    this.setState({ selectedProperty: null });
  }

  onMetadataUpdate(newMetadata) {
    let metadata = Object.assign({}, this.props.metadata, newMetadata);

    this.setValue(this.state.value, metadata);
  }

  setValue(value, metadata = this.props.metadata) {
    this.props.setValue(this.props.index, value, metadata);
  }

  handleReferenceChange(option) {
    let newValue = option === null ? '' : option.value;

    this.setValue(newValue, { reference: newValue });
  }

  hasOptionsToReference(props = this.props) {
    return (
      props.references &&
      typeof props.references === 'object' &&
      props.references.length > 0
    );
  }

  isReferenceEnabled() {
    return this.state.dropdown === 'reference';
  }

  shouldShowWarning() {
    return (
      this.props.referenceWarning &&
      this.isReferenceEnabled() &&
      this.hasPropertySelected() &&
      this.state.selectedProperty.customLabel === 'Node'
    );
  }

  shouldShowError() {
    const prefixesRegex = new RegExp(`\\b(${this.octetPrefixes.join('|')})\\b`);
    if (!this.state.error || prefixesRegex.test(this.state.error)) {
      return false;
    }
    return true;
  }

  renderWarning() {
    return (
      <small className='ui warning message info reference-warning'>
        Node Group properties referencing Node properties will only be exported
        at the Node level.
      </small>
    );
  }

  isDHCP() {
    const { value } = this.state;

    return value && !this.isReferenceEnabled()
      ? value.toLowerCase().trim().includes('dhcp')
      : false;
  }

  render() {
    const hasOctetReplacement =
      this.props.type === 'ip' &&
      (this.props.ipFieldData || {}).allowOctetReplacement;
    let removeClassNames = [
        'ui',
        'red',
        'icon',
        'button',
        'multiple-value-button',
        'io-form-button',
        'multiple-value-button-remove',
      ],
      className = this.props.className;

    removeClassNames.push(this.props.className);
    if (typeof this.state.error !== 'undefined') {
      className += ' error';
    }

    return (
      <div
        className={this.classes.join(' ')}
        data-testid={'field-item'}
        onMouseEnter={() => {
          if (!this.props.fixed) {
            this.setState({ button: true });
          }
        }}
        onMouseLeave={() => {
          if (!this.props.fixed) {
            this.setState({ button: false });
          }
        }}
      >
        <div
          className={`${this.hasOptionsToReference() ? 'property-selector-container ' : ''}property-container`}
        >
          <If
            condition={
              this.hasOptionsToReference() && !this.props.parentDisabled
            }
          >
            <EnhancedDropdown
              button
              className='icon'
              icon='dropdown'
              text=''
            >
              <Dropdown.Menu>
                <Dropdown.Header content='Content Type' />
                <Dropdown.Divider />
                {this.dropdownOptions.map((opt) => {
                  return (
                    <Dropdown.Item
                      key={opt.key}
                      active={this.state.dropdown === opt.value}
                      className={opt.value}
                      text={opt.text}
                      value={opt.value}
                      onClick={() => this.selectDropdown(opt.value)}
                    />
                  );
                })}
              </Dropdown.Menu>
            </EnhancedDropdown>
          </If>

          <If
            condition={
              !this.hasOptionsToReference() || this.state.dropdown === 'value'
            }
          >
            <div
              className={
                this.hasOptionsToReference() ? 'property-selector-field' : ''
              }
            >
              <DynamicField
                ref='input'
                className={className}
                default={this.props.default}
                fieldmeta={this.props.fieldmeta}
                focus={this.props.focus}
                getSufixName={(field) => this.getSufixName(field)}
                guide={false}
                hasNameSuffix={
                  hasOctetReplacement || this.props.addValueStrToInputName
                }
                id={this.props.id}
                mask={this.props.mask}
                metadata={this.props.metadata}
                name={this.props.name}
                parentDisabled={this.props.parentDisabled}
                placeholder={this.props.placeholder}
                readonly={this.props.readonly}
                required={this.props.required}
                semantic={this.props.semantic}
                type={this.props.type}
                value={this.props.value}
                onValue={this.setValue.bind(this)}
              />
            </div>
          </If>

          <If
            condition={
              this.hasOptionsToReference() && this.isReferenceEnabled()
            }
          >
            <div className='property-selector-dropdown'>
              <If condition={!this.props.supressFields}>
                <input
                  readOnly
                  name={`${this.props.name}[value]`}
                  type='hidden'
                  value={
                    this.hasPropertySelected()
                      ? this.state.selectedProperty.templateName
                      : ''
                  }
                />
                <input
                  readOnly
                  name={`${this.props.name}[reference]`}
                  type='hidden'
                  value={
                    this.hasPropertySelected()
                      ? this.state.selectedProperty.value
                      : ''
                  }
                />
              </If>
              <If condition={!this.props.parentDisabled}>
                <Select
                  isClearable
                  isDisabled
                  className={'ReferenceSelect'}
                  maxMenuHeight={40}
                  optionRenderer={SelectOptions}
                  options={this.props.references}
                  placeholder='Select a Property'
                  required={this.props.required}
                  value={this.state.selectedProperty}
                  onChange={this.handleReferenceChange.bind(this)}
                />
              </If>
              <If
                condition={
                  this.props.parentDisabled && this.state.selectedProperty
                }
              >
                <span className='selectedReference'>
                  {this.state.selectedProperty.label}
                </span>
              </If>
            </div>
          </If>
          <If condition={this.shouldShowWarning()}>{this.renderWarning()}</If>
        </div>

        <If condition={hasOctetReplacement}>
          <OctetReplacementField
            {...this.props.ipFieldData}
            canCreateOption={
              this.isReferenceEnabled() ||
              this.props.ipFieldData.canCreateOption
            }
            error={this.shouldShowError() ? undefined : this.state.error}
            errorPrefixes={this.octetPrefixes}
            isDHCP={this.isDHCP()}
            metadata={this.props.metadata || {}}
            name={this.props.name}
            value={this.state.value}
            onAppendChange={this.onAppendUpdate.bind(this)}
            onOctetChange={this.onMetadataUpdate.bind(this)}
          />
        </If>

        <If condition={this.state.button && this.props.multiple}>
          <a
            className={removeClassNames.join(' ')}
            data-testid={'remove-button'}
            onClick={() => this.props.removeValue(this.props.index)}
          >
            <i className='icon minus circle'></i>
          </a>
        </If>
        <If condition={this.shouldShowError()}>
          <div className='error'>{this.state.error}</div>
        </If>
      </div>
    );
  }
}

module.exports = FieldItem;
